package one.healthium.meal_plans.tutorial.screen

internal data class PersonalMealPlanTutorialUiState(
    val loading: Boolean = false,
)
